<template>
  <div class="detailCon">
    <div class="detailTip">
      <a>当前位置:</a>
      <a class="cursonBtn" @click="goHome">首页</a> >
      <router-link class="cursonBtn" :to="{ path: '/productlist' }"
        >金融需求</router-link
      >
      >
      <a>{{ prod.name }}</a>
    </div>
    <!-- 产品列表 -->
    <list-com :product="prod" @applyNow="applyNow" />
    <!-- 项目详情 -->
    <div class="project_detail">
      <p>项目详情</p>
      <ul class="detail_tit">
        <li class="detail_li">
          <h3>产品介绍</h3>
          <p class="produce">
            {{ prod.explain }}
          </p>
        </li>
        <li class="detail_li">
          <h3>申请条件</h3>
          <ul>
            <li v-for="(apply, index) in prod.data" :key="index">
              {{ apply }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!-- 返回按钮 -->
    <div class="back_div">
      <router-link tag="div" :to="{ path: '/productlist' }">返回</router-link>
    </div>
  </div>
</template>
<script>
import listCom from "./component/detaillist";
import { initList } from "../../util/initList.js";
import { getlogin } from "@/api/index.js";
export default {
  components: {
    listCom
  },
  data() {
    return {
      prod: {}
    };
  },
  created() {
    window.scrollTo(0, 0);
    if (this.$route.query.index) {
      this.prod = initList[this.$route.query.index];
    } else {
      this.prod = initList[0];
    }
  },
  methods: {
    goHome() {
      window.parent.frames.location.href = "https://www.zgcqianfan.com/";
    },
    applyNow() {
      let accessToken = "";
      if (this.$route.query.accessToken) {
        sessionStorage.setItem("accessToken", this.$route.query.accessToken);
        accessToken = this.$route.query.accessToken;
      } else if (sessionStorage.getItem("accessToken")) {
        accessToken = sessionStorage.getItem("accessToken");
      }
      if (accessToken) {
        let param = {
          accessToken
        };
        getlogin(param).then(res => {
          if (res.data.code == 200) {
            let userinfo = res.data.data;
            userinfo.qianfanProductKey = Number(this.$route.query.index)
              ? Number(this.$route.query.index) + 1
              : 1;
            window.parent.frames.location.href =
              "https://isyfin.youpinsanyue.com/#/checkinfo?userinfo=" +
              JSON.stringify(userinfo);
          } else {
            console.log("重新登录", res);
            // 重新登录
            window.parent.frames.location.href =
              "https://www.zgcqianfan.com/member/login.html?redirectUrl=" +
              encodeURIComponent(
                "https://www.zgcqianfan.com/finance/detail.jsp?index=" +
                  Number(this.$route.query.index)
              );
          }
        });
      } else {
        window.parent.frames.location.href =
          "https://www.zgcqianfan.com/member/login.html?redirectUrl=" +
          encodeURIComponent(
            "https://www.zgcqianfan.com/finance/detail.jsp?index=" +
              Number(this.$route.query.index)
          );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
ul,
ol {
  list-style: none;
}
.detailCon {
  width: 100%;
  background-color: #f6f6f6;
  padding-bottom: 92px;
  height: max-content;
  .detailTip {
    height: 12px;
    display: inline-block;
    font-family: SourceHanSansSC-Regular;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #6d717e;
    margin: 15px 0 15px 15%;
    .cursonBtn {
      cursor: pointer;
      text-decoration: none;
      color: #6d717e;
    }
  }
  .project_detail {
    width: 80%;
    margin: 20px auto;
    background-color: #ffffff;
    border-radius: 10px;
    min-height: 100px;
    margin-bottom: 50px;
    p {
      height: 60px;
      background-color: #f1f2f5;
      border-radius: 10px 10px 0px 0px;
      font-size: 20px;
      color: #333;
      line-height: 60px;
      padding-left: 40px;
    }
    .detail_tit {
      padding: 34px 8% 54px 6%;
      .detail_li {
        background: #fff;
        margin-bottom: 72px;
        font-family: SourceHanSansCN-Regular;
        &:last-child {
          margin-bottom: 0;
        }
        h3 {
          color: #333333;
          font-size: 18px;
          font-weight: normal;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 20px;
          font-family: SourceHanSansCN-Regular;
          &::before {
            content: "  ";
            display: inline-block;
            width: 4px;
            height: 18px;
            background-color: #3da0fd;
            border-radius: 2px 2px 2px 2px;
            margin-right: 6px;
          }
        }
        .produce {
          font-size: 16px;
          color: #666666;
          line-height: 30px;
          background: #fff;
          padding-left: 10px;
          font-family: SourceHanSansCN-Regular;
        }
        ul {
          padding-left: 10px;
          li {
            font-size: 16px;
            line-height: 30px;
            color: #666;
          }
        }
      }
    }
  }

  .back_div {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      cursor: pointer;
      width: 86px;
      height: 39px;
      border-radius: 4px;
      border: solid 1px #3da0fd;
      color: #3da0fd;
      font-size: 14px;
      line-height: 39px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/qianfan/productDetail.vue